import React from 'react';
import styles from './RecordCompareRecordObject.module.scss';
import I18n from '../../../I18n/I18n/I18n';
export default function FileDownload(_ref) {
  var uri = _ref.uri,
    label = _ref.label;
  if (!uri) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: uri,
    className: styles.span
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.record-compare.labels.download"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, ' ', /*#__PURE__*/React.createElement(I18n, {
    i18n: label
  })));
}